function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBagBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.924 511.924",
    style: {
      enableBackground: "new 0 0 511.924 511.924"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.702,
    y: 102.776,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 136.967,
    height: 59.985
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M206.58,102.844l-43.037-84.047c0,0,52.911-8.544,93.32,0c41.544,8.784,90.623,0,90.623,0l-43.643,83.955"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M306.47,162.805c40.231,35.207,74.438,66.411,102.297,98.254c80.415,91.913,14.352,235.865-107.773,235.865h-90.335 c-123.227,0-188.255-145.655-106.236-237.621c31.965-35.842,68.287-65.127,101.478-96.498"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 119.677,
    y1: 162.761,
    x2: 187.702,
    y2: 132.769
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 324.668,
    y1: 132.769,
    x2: 399.226,
    y2: 162.761
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M298.124,397.249c-10.259,7.234-22.394,11.416-35.397,11.416c-36.839,0-66.704-33.569-66.704-74.978s29.864-74.978,66.704-74.978 c15.952,0,30.596,6.294,42.074,16.793"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 178.3,
    y1: 307.57,
    x2: 259.977,
    y2: 307.57
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 178.3,
    y1: 359.806,
    x2: 251.205,
    y2: 359.806
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBagBudget);
export default __webpack_public_path__ + "static/media/money-bag-budget.5cc2bcfd1c5781a35901fcde4835015c.svg";
export { ForwardRef as ReactComponent };